import { Badge, IconButton } from "@mui/material";

const ActionIconButton = ({ icon, label, style = {}, clicked, color = "default", onClick, ...props }) => {

    return (
        <div style={{ marginBottom: "10px" }}>
            <IconButton
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: clicked ? "#c8d1e8" : "transparent",
                    padding: "10px",
                    borderRadius: "8px",
                    ...style,
                }}
                onClick={onClick}
                {...props}
            >
                {icon}
                <span style={{ fontSize: "12px", marginTop: "0px" }}>{label}</span>
            </IconButton>
        </div>
    );
};

export default ActionIconButton;
